import { Source } from '@store';

import { HREF_REGEXP } from './constants';

export const arrayWithUniques = <T = Source>(data: T[], key: keyof T): string[] => {
	return Array.from(new Set(data.map(item => (item[key] as string)[0].toLowerCase())));
};

export const sortByKey = <T = Source>(data: T[], key: keyof T): T[] => {
	return data.toSorted((a: T, b: T) => (a[key] as string).localeCompare(b[key] as string));
};

export const composeClassName = (...classNames: Array<string | undefined>): string =>
	classNames.filter(Boolean).join(' ');

export const withLinks = (input: string) => input.replace(HREF_REGEXP, (x: string) => `<a href="${x}">${x}</a>`);
